// extracted by mini-css-extract-plugin
module.exports = {"modal-card":"UploadDocumentButton_modal-card_10vuz","modal-card-body":"UploadDocumentButton_modal-card-body_luKZV","spinAround":"UploadDocumentButton_spinAround_3lzzG"};